import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';

class RTIsoPageForm extends Form {
	state = {
		data: { isoImage: [] },
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		isoImage: Joi.array().min(1).required().label('Isometric Drawing Sheet'),
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.isoImage);

		this.setState({ data: { isoImage: [] } });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				{this.renderFileInput({
					max: 1,
					multiple: false,
					name: 'isoImage',
					accept: 'image/*,application/pdf',
					label: 'Isometric Drawing Sheet',
					sublabel: 'Upload Isometric Drawing Sheet',
					types: utils.getFileUploadTypes(),
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default RTIsoPageForm;
